import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

import useConsumerCardGenerationSocketStats from '../../../../id8/hooks/useConsumerCardGenerationSocketStats';
import { consumerGetPromptById } from '../../../../redux/consumer/id8/consumerId8Actions';
import { changeActiveGenStatus, changeGeneratingStatusForPrompt } from '../../../../redux/id8/id8Reducer';
import { clearNotificationStatus, setNotificationStatus } from '../../../../redux/notifier/notifierReducer';
import { addPromptToImages } from '../../../../redux/id8/id8Actions';
import useImagesGenerationStatus from '../../../../id8/hooks/useImagesGenerationStatus';
import { ID8_GEN_TYPES, PROMPT_TYPE } from '../../../../constants';

function ImagesGeneratingConsumerStatusController({ promptType, generationLabel }) {
  const dispatch = useDispatch();
  const { projectName, projectPassword } = useSelector((state) => state.consumer.id8);

  const checkStatus = async () => {
    const response = await axios.post(`/api/consumer/project/status/is/id8/content/generating`, {
      projectRequest: {
        projectName,
        projectPassword,
      },
      request: promptType,
    });

    dispatch(changeActiveGenStatus({ genType: mappedPromptTypeToGenType[promptType], status: response.data }));
  };

  useConsumerCardGenerationSocketStats((state) => state.consumer.id8, promptType, {
    onCreated: (frameId) => {
      dispatch(addPromptToImages({ promptId: frameId, promptType }));
    },
    onGeneratingStart: (frameId) => {
      dispatch(changeGeneratingStatusForPrompt({ id: frameId, generating: true, promptType }));
    },
    onGeneratingFinish: (frameId) => {
      dispatch(changeGeneratingStatusForPrompt({ id: frameId, generating: false, promptType }));
    },
    onImageGenerated: ({ bucketId }) => {
      dispatch(consumerGetPromptById({ bucketId, promptType }));
    },
    onAllImagesGenerated: () => {
      dispatch(changeActiveGenStatus({ genType: mappedPromptTypeToGenType[promptType], status: false }));
    },
  });

  const isImagesGenerating = useImagesGenerationStatus({ genType: mappedPromptTypeToGenType[promptType] });

  useEffect(() => {
    if (isImagesGenerating) {
      dispatch(setNotificationStatus(generationLabel ?? 'generationInProgress'));
    } else {
      dispatch(clearNotificationStatus());
    }

    return () => {
      dispatch(clearNotificationStatus());
    };
  }, [isImagesGenerating, generationLabel, dispatch]);

  useEffect(() => {
    checkStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default ImagesGeneratingConsumerStatusController;

const mappedPromptTypeToGenType = {
  [PROMPT_TYPE.IDEA]: ID8_GEN_TYPES.IMAGES,
  [PROMPT_TYPE.RECREATE]: ID8_GEN_TYPES.RECREATE,
};
